import React from 'react';
import classNames from 'classnames/bind';
import { RichText } from '@components';
import { CategoryLandingPageFormattedTextSection } from '@services';
import styles from '../CategoryLandingPage.module.scss';

const CN = 'category-landing-page';
const sectionClassName = `${CN}__section`;
const cx = classNames.bind(styles);

interface Props {
  section: CategoryLandingPageFormattedTextSection;
}

export const FormattedText: React.FC<Props> = ({
  section: {
    formatted_text: {
      text
    }
  }
}) => (
  <div className={ cx(sectionClassName) }>
    <RichText richText={ text } />
  </div>
);
